import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core/core.component';
import { NavbarComponent } from './navbar/navbar.component';
import { Plugins } from 'protractor/built/plugins';
import { PluginsModule } from '../plugins/plugins.module';


@NgModule({
  declarations: [CoreComponent, NavbarComponent,],
  imports: [
    CommonModule,
    CoreRoutingModule,
    PluginsModule
  ],
  exports: [
    CoreComponent,
  ],
  providers: []
})
export class CoreModule { }
